module.exports = __webpack_public_path__ + "img/kantina.8fffd6b2.png";